import { IconCheckOutline18 as Check } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/cn"
import { CommandItem } from "@productlane/ui/src/components/internal/command"

import type { SharedFilterItemsProps } from "@/components/filters"
import { SOURCE_OPTIONS } from "@/components/filters/source-options"
import { useCompaniesFilterState } from "../companies-filter-state"

export function SourceFilterItems({ onSelect }: SharedFilterItemsProps) {
	const { sources, addSource, removeSource } = useCompaniesFilterState()

	return (
		<>
			{SOURCE_OPTIONS.map(({ value, label, Icon }) => {
				const isSelected = sources.includes(value)
				return (
					<CommandItem
						key={value}
						onSelect={() => {
							if (isSelected) {
								removeSource(value)
							} else {
								addSource(value)
							}
							onSelect()
						}}
					>
						<div className="flex w-full items-center gap-2">
							<Icon className="h-4 w-4 shrink-0 text-secondary" />
							<span className="flex-1 truncate">{label}</span>
							<Check
								className={cn("h-4 w-4 shrink-0", {
									"opacity-100": isSelected,
									"opacity-0": !isSelected,
								})}
							/>
						</div>
					</CommandItem>
				)
			})}
		</>
	)
}
